import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CircularProgress, Alert } from '@mui/material';

function CVPage() {
  const [selectedTags, setSelectedTags] = useState([]);
  const [cvSections, setCvSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchCVData();
  }, []);

  const fetchCVData = async () => {
    try {
      const response = await axios.get('/api/cv/sections');
      setCvSections(response.data.sections);
    } catch (error) {
      console.error('Error fetching CV data:', error);
      setError('Failed to load CV data');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    // Format date to 'maand jjjj' in Dutch
    return new Date(dateString).toLocaleDateString('nl-NL', {
      month: 'long',
      year: 'numeric'
    });
  };

  const formatDateRange = (startDate, endDate) => {
    const start = formatDate(startDate);
    // Use 'Heden' for Dutch translation of 'Present'
    const end = endDate ? formatDate(endDate) : 'Heden';
    return `${start} - ${end}`;
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '2rem' }}>
        <CircularProgress />
        <p>Loading CV data...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Alert severity="error">{error}</Alert>
      </div>
    );
  }

  return (
    <div>
      <h1>Waar kan ik uw organisatie mee helpen?</h1>
      
      <p>Als interimmer breng ik 26 jaar ervaring mee als eindverantwoordelijk schoolleider. Als adviseur treed ik vaak in het spanningsgebied tussen College van Bestuur en schoolleiders of het spanningsgebied tussen schoolleiding, medewerkers en MR.</p>
      <p>Belangrijke aspecten van mijn werk als interimmer zijn het brengen van rust en duidelijkheid en het interveniëren in een ineffectieve cultuur. Kernwoorden zijn professionalisering, voorspelbaarheid & betrouwbaarheid, plezier in waardevol en dankbaar werk.</p>
      
      <hr className="blue-line" />

      <h1>Diensten</h1>

      <div className="grid-container">
            <div className="grid-item">
                <h2>Interim</h2>
                <p>Ik breng rust vanuit mijn ervaring als schoolleider en het daarbij behorende overzicht. Daarin laat ik me leiden door wat er op de werkvloer gebeurt; in het klaslokaal, in de pauze, in de docentenkamer en het gesprek met ouders, medewerkers en leerlingen. Ik kan – zonder oordeel - goed analyseren en goed over het voetlicht brengen wat ik zie. Ik kan goed aansluiten bij bestaande kwaliteiten om waar nodig om te buigen of te verbeteren. En hoewel de laatste drie zinnen alle beginnen met 'ik' heb ik geen last van mijn eigen opvattingen of ego. </p>
            </div>
            <div className="grid-item">
                <h2>Coaching</h2>
                <p>Ik ben gecertificeerd als coach voor schoolleiders en bestuurders.</p>
            </div>
            <div className="grid-item">
                <h2>Schoolontwikkeling</h2>
                <p>Ik heb ik geadviseerd over de invoering van nieuwe manieren van organiseren, over de aanpak van ervaren onveiligheid of ervaren werkdruk. Ik heb gewerkt in het regulier onderwijs, Montessori-onderwijs, Agora en Vrije School.</p>
            </div>
            <div className="grid-item">
                <h2>Rust</h2>
                <p>Als schoolleider heb ik 26 jaar goed lopende scholen alert gehouden, heb ik gebouwd aan nieuwe onderwijsconcepten, heb ik op scholen in turbulentie rust gebracht en heb ik scholen en locaties verbonden.</p>
            </div>
        </div>
      
      <hr className="blue-line" />

      <h1>Mijn ervaring op een rij</h1>

      {/* Render CV sections */}
      {cvSections.map(section => (
        <div key={section.id} className="cv-section">
          <h2>{section.title}</h2>
          {/* {section.description && <p>{section.description}</p>} */}

          {section.items
            .filter(item => {
              if (selectedTags.length === 0) return true;
              return selectedTags.some(tag => 
                item.subtitle?.includes(tag) || 
                item.location?.includes(tag)
              );
            })
            .map(item => (
              <div className="work-item" key={item.id}>
                <h3>{item.title}</h3>
                {item.subtitle && <h4>{item.subtitle}</h4>}
                {(item.start_date || item.end_date) && (
                  <p>{formatDateRange(item.start_date, item.end_date)}</p>
                )}
                {item.location && <p>📍 {item.location}</p>}
                {item.description && <p>{item.description}</p>}
              </div>
            ))
          }
        </div>
      ))}

    </div>
  );
}

export default CVPage;